import { apiClient } from './apiErrorHandling';

/**
 * 카테고리 크롤링 API 호출 함수
 * @param {Object} selectedCategory - 선택된 카테고리 객체
 * @param {string} selectedSite - 선택된 사이트명
 * @returns {Promise<Object>} 크롤링 응답 데이터
 */
export const crawlCategoryProducts = async (selectedCategory, selectedSite) => {
    if (!selectedCategory || !selectedSite) {
        throw new Error('카테고리와 사이트를 선택해주세요.');
    }

    // 사이트 매핑
    const siteMapping = {
        '올리브영': 'oliveyoung',
        '무신사': 'musinsa',
        '위버스': 'weverse',
        '케이타운': 'ktown'
    };
    const siteCode = siteMapping[selectedSite] || selectedSite.toLowerCase();

    // 요청 데이터 구성
    const requestData = {
        site: siteCode,
        categoryId: selectedCategory.categoryId || selectedCategory.dispCatNo || selectedCategory.category_id
    };

    console.log('선택된 카테고리 데이터:', selectedCategory);
    console.log('크롤링 요청 데이터:', requestData);

    // 크롤링 API 호출 (5분 타임아웃)
    const response = await apiClient.post('/crawler/crawl-category-products', requestData, { timeout: 300000 });

    console.log('크롤링 응답:', response.data);
    return response.data;
};

/**
 * 크롤링 에러 메시지 처리 함수
 * @param {Error} error - 에러 객체
 * @returns {string} 처리된 에러 메시지
 */
export const getCrawlingErrorMessage = (error) => {
    const errorMessage = error.response?.data?.detail 
        ? (typeof error.response.data.detail === 'string' 
            ? error.response.data.detail 
            : JSON.stringify(error.response.data.detail))
        : '크롤링 중 오류가 발생했습니다.';
    
    return `${errorMessage}`;
};
